import { Typography } from 'antd';
import React from 'react';

const Patch = () => {
  return (
    <Typography.Text type='secondary' style={{ marginRight: '8px' }}>
      PATCH
    </Typography.Text>
  );
};

export default Patch;
